// extracted by mini-css-extract-plugin
export default {"Wrapper":"Success_Wrapper__NAQR7"};